// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2LEIC","selected":"Chip_selected__3N2pr"};